import { createRouter, createWebHistory } from "vue-router";
import { routes } from "./routes";
import { $session } from "framework";
import { useAuthStore } from "@/store/auth"; // Pinia store import

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const needsAuth = to.matched.some(
      record => record.meta?.auth === true
  );

  if (!needsAuth) {
    return next();
  }

  /* --------------------------------------------------
   * isAuthenticated가 null이면 최초 로그인 확인
   * -------------------------------------------------- */
  const authStore = useAuthStore();

  if (authStore.isAuthenticated === null) {
    const ok = await $session.ensureLoggedIn();
    authStore.setAuthenticated(ok); // Pinia action or direct assignment
  }

  if (!authStore.isAuthenticated) {
    return next({
      name: "login",
      query: { redirect: to.fullPath },
    });
  }

  return next();
});

export default router;